<script setup lang="ts">
    import { onMounted, ref } from 'vue';
    import LoadingDots from '../LoadingDots.vue';

    const show = ref(false);

    onMounted(() => {
        show.value = true;

        return () => {
            show.value = false;
        };
    });
</script>
<template>
    <Transition name="fade">
        <div v-if="show" class="bg-white/75 w-full h-full flex items-start pt-32 justify-center">
            <div class="fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
                <LoadingDots />
            </div>
        </div>
    </Transition>
</template>
